<template>
    <el-container style="width:100%">
        <el-header style="height:7%">
            <el-form>
                <el-row>
                    <el-col :span="24">
                        <el-form-item style="margin-left:5px;">
                            <td-button type="primary" :permissions="permissionsView" :loading="loading" @click="btnQuery">{{ $t('pgCommon.TO_BE_AUDITED') }}</td-button>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </el-header>
        <el-main>
            <!-- 加载表格 -->
            <td-table
                :columns="columns"
                :permissions="permissionsView"
                ref="leaveBill"
                :rowKey="rowKey"
                :dataSource="tableData"
                :pageSize="pageSize"
                :currentPage="currentPage"
                :total="total"
                @handleSizeChange="handleSizeChange"
                @currentChange="currentChange"
            ></td-table>
            <!-- 加载dialog -->
            <dialog-approval
                v-if="dialogLeaveBillVisible"
                :isAddData="isAddData"
                :dialogLeaveBillVisible="dialogLeaveBillVisible"
                :editItem="editItem"
                :title="title"
                @dialogLeaveBillClose="dialogLeaveBillClose"
            ></dialog-approval>
        </el-main>
    </el-container>
</template>

<script>
import Api from './assets/api.js';
import dialogApproval from './components/dialogApproval.vue';
export default {
    // 初始化渲染
    components: {
        'dialog-approval': dialogApproval
    },
    // 在页面渲染完成之后进行初始化工作
    mounted() {
        this.btnQuery();
    },
    // 定义数据
    data() {
        return {
            columns: [
                {
                    prop: 'processDefinitionName',
                    label: this.$t('pgCommon.WORK_FLOW_CAPTION'),
                    align: 'center',
                    tableWidth: '150'
                },
                {
                    prop: 'assignee',
                    align: 'center',
                    label: this.$t('pgCommon.WAIT_APPROVAL_PERSON')
                },
                {
                    prop: 'createTime',
                    label: this.$t('pgCommon.APPROVAL_TIME'),
                    align: 'center',
                    tableWidth: '250'
                },
                {
                    prop: '',
                    label: this.$t('common.OPERATE'),
                    tableWidth: '150',
                    align: 'center',
                    render: (createElement, params) => {
                        return createElement('div', [
                            createElement(
                                'td-button',
                                {
                                    props: { permissions: this.permissionsEdit, type: 'text', size: 'small' },
                                    on: {
                                        click: () => {
                                            this.btnExit(params.row);
                                        }
                                    }
                                },
                                this.$t('pgCommon.APPROVAL')
                            )
                        ]);
                    }
                }
            ],
            permissionsView: ['workflow:view'],
            permissionsEdit: ['workflow:edit'],
            tableData: [],
            rowKey: 'id',
            isAddData: true, // 是否为添加数据
            pageSize: 10, // 每页条数
            currentPage: 1, // 当前页
            total: 0, // 总条数
            loading: false, // 按钮是否为加载状态
            dialogLeaveBillVisible: false
        };
    },
    // 方法的实现
    methods: {
        // 添加
        btnAdd() {
            this.title = 'pgCommon.WORK_FLOW_TEST';
            this.isAddData = true;
            this.dialogLeaveBillVisible = true;
        },
        // 查询数据
        btnQuery() {
            this.loading = true;
            this.currentPage = 1;
            this.queryList();
        },
        queryList() {
            let param = {
                userName: sessionStorage.getItem('username'),
                pageNum: this.currentPage,
                pageSize: this.pageSize,
                isNeedPage: true
            };
            Api.queryApprovalLeaveBill(JSON.stringify(param), response => {
                if (response.status !== this.$common.login.RESPONSE_STATUS) {
                    this.$message({ type: 'error', showClose: true, message: this.$t('error.ERROR_RESPONSE') });
                    this.loading = false;
                    return;
                }
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ type: 'error', showClose: true, message: response.data.statusMessage });
                    this.loading = true;
                    this.$log.error('/LeaveBill/queryApprovalLeaveBill', response.data.statusMessage);
                    return;
                }
                this.tableData = response.data.content;
                this.total = response.data.count;
                this.loading = false;
            });
        },
        // 编辑
        btnExit(row) {
            this.editItem = row;
            this.title = this.$t('common.EDIT');
            this.isAddData = false;
            this.dialogLeaveBillVisible = true;
            this.sIdDisabled = true;
        },
        // 获取每页条数
        handleSizeChange(pageSize) {
            this.pageSize = pageSize;
            this.queryList();
        },
        // 获取当前页
        currentChange(currentPage) {
            this.currentPage = currentPage;
            this.queryList();
        },
        // 关闭页面
        dialogLeaveBillClose() {
            this.dialogLeaveBillVisible = false;
            this.btnQuery();
        }
    }
};
</script>
<style scoped>
.btnStyle {
    margin-left: 100px;
}
</style>
